import { DepositAccountName, InvestAccountName, MortgageAccountName, } from "../types";
export var customizations = [
    {
        customizationId: "07c367e6-579e-44fe-bd21-049ad5bacd8e",
        customerId: "244858532452211002",
        channel: "WEB",
        views: [
            {
                name: "DASHBOARD",
                value: "TILE",
            },
        ],
        lobs: [
            {
                name: "DEPOSIT",
                order: 1,
            },
            {
                name: "INVEST",
                order: 2,
            },
        ],
        accountTypes: [
            {
                lob: "DEPOSIT",
                name: DepositAccountName.IRA,
                order: 1,
            },
            {
                lob: "DEPOSIT",
                name: DepositAccountName.CD,
                order: 2,
            },
            {
                lob: "DEPOSIT",
                name: DepositAccountName.SAVINGS,
                order: 3,
            },
            {
                lob: "DEPOSIT",
                name: DepositAccountName.CHECKING,
                order: 4,
            },
            {
                lob: "INVEST",
                name: InvestAccountName.INVS,
                order: 5,
            },
            {
                lob: "INVEST",
                name: InvestAccountName.INVW,
                order: 6,
            },
            {
                lob: "INVEST",
                name: InvestAccountName.INVA,
                order: 7,
            },
            {
                lob: "MORTGAGE",
                name: MortgageAccountName.MORTGAGE,
                order: 8,
            },
            {
                lob: "MORTGAGE",
                name: MortgageAccountName.HOME_EQUITY,
                order: 9,
            },
        ],
        widgets: [],
    },
];
//# sourceMappingURL=index.js.map